import { createContext } from 'react';
// import { useStateManager } from '../hooks/useStateManager';

const defaultState: any = [];

const ProfileContext = createContext(defaultState);

export default ProfileContext;
